import React from 'react';
import {
  Placeholder,
  RouteData,
  ComponentRendering,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { Grid, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

type RenderingProps = WithSitecoreContextProps & {
  rendering: RouteData | ComponentRendering;
};

const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: '40px',
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
}));

const SectionWithMargin = ({ rendering }: RenderingProps): React.JSX.Element => {
  return (
    <StyledContainer maxWidth="lg">
      <Grid container direction="row">
        <Grid item xs={12}>
          <Placeholder name="section_with_margin" rendering={rendering} />
        </Grid>
      </Grid>
    </StyledContainer>
  );
};

export default SectionWithMargin;
